import { FadeIn, FadeOut } from "appworks/graphics/animation/base-animations";
import { AbstractSceneTransition } from "appworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { gameState } from "appworks/model/game-state";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";

const FADE_IN_DURATION: number = 350;
const FADE_OUT_DURATION: number = 350;

export class DMFInstantWinsSceneTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        const isFreespins: boolean = gameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord;
        const activePrefix: string = isFreespins ? "fs" : "bg";
        const inactivePrefix: string = isFreespins ? "bg" : "fs";

        const text: Text = this.layer.getText("value");
        text.text = "";
        const activeInfoPanel: Sprite = this.layer.getSprite(`${activePrefix}_info_panel`);
        const inactiveInfoPanel: Sprite = this.layer.getSprite(`${inactivePrefix}_info_panel`);
        inactiveInfoPanel.visible = false;

        return new Parallel([
            () => FadeIn(activeInfoPanel, FADE_IN_DURATION),
            () => FadeIn(text, FADE_IN_DURATION)
        ]);
    }

    public out(): Contract<void> {
        const isFreespins: boolean = gameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord;
        const activePrefix: string = isFreespins ? "fs" : "bg";
        const inactivePrefix: string = isFreespins ? "bg" : "fs";

        const text: Text = this.layer.getText("value");
        const activeInfoPanel: Sprite = this.layer.getSprite(`${activePrefix}_info_panel`);
        const inactiveInfoPanel: Sprite = this.layer.getSprite(`${inactivePrefix}_info_panel`);
        inactiveInfoPanel.visible = false;

        return new Parallel([
            () => FadeOut(activeInfoPanel, FADE_OUT_DURATION),
            () => FadeOut(text, FADE_OUT_DURATION)
        ]);
    }
}
